/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespBreadcrumbs_item$ref = any;
type PdpRespDealerDetails_item$ref = any;
type PdpRespDetails_item$ref = any;
type PdpRespExitModal_item$ref = any;
type PdpRespHeroCarouselPrint_item$ref = any;
type PdpRespHeroCarousel_item$ref = any;
type PdpRespIconBubblesWrapper_item$ref = any;
type PdpRespPriceNegotiationToastLoader_item$ref = any;
type PdpRespRequestHoldToastLoader_item$ref = any;
type PdpRespSeoLinks_item$ref = any;
type PdpRespShippingReturns_item$ref = any;
type PdpRespSidebarBlurbs_item$ref = any;
type PdpRespSidebarButtons_item$ref = any;
type PdpRespSidebarContact_item$ref = any;
type PdpRespSidebarSellerInfo_seller$ref = any;
type PdpRespSimilarItemsFooter_item$ref = any;
type PdpRespSimilarItemsGridSeller_item$ref = any;
type PdpRespSimilarItemsLanding_item$ref = any;
type PdpRespSwatchSelector_item$ref = any;
type PdpRespTitle_item$ref = any;
type PdpSharedDescriptionAboutCreator_item$ref = any;
type PdpSharedDescriptionAboutMaker_item$ref = any;
type PdpSharedDescriptionAbout_item$ref = any;
type PdpSharedDescriptionAdditionalOptions_item$ref = any;
type PdpSharedPromoCode_item$ref = any;
type PdpSharedQuantitySelect_item$ref = any;
type PdpSharedRecentHistoryTracker_item$ref = any;
type PriceDisplay_item$ref = any;
type SuspectedTradeUserLoader_item$ref = any;
export type PdpRespContainer_item$ref = any;
export type PdpRespContainer_item = {
    readonly serviceId: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
    readonly defaultSkuId: string | null;
    readonly itemType: string | null;
    readonly seller: {
        readonly " $fragmentRefs": PdpRespSidebarSellerInfo_seller$ref;
    } | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly skuLeadTime: string | null;
    } | null> | null;
    readonly " $fragmentRefs": PdpRespExitModal_item$ref & PdpRespSimilarItemsLanding_item$ref & PdpRespBreadcrumbs_item$ref & PdpRespHeroCarouselPrint_item$ref & PdpRespIconBubblesWrapper_item$ref & PdpRespTitle_item$ref & PdpRespSidebarButtons_item$ref & PdpRespSidebarBlurbs_item$ref & PdpSharedDescriptionAbout_item$ref & PdpSharedDescriptionAboutCreator_item$ref & PdpSharedDescriptionAdditionalOptions_item$ref & PdpRespShippingReturns_item$ref & PdpRespSidebarContact_item$ref & PdpRespSeoLinks_item$ref & PdpRespSimilarItemsGridSeller_item$ref & PdpRespSimilarItemsFooter_item$ref & PdpSharedQuantitySelect_item$ref & PdpSharedRecentHistoryTracker_item$ref & PriceDisplay_item$ref & PdpSharedPromoCode_item$ref & PdpRespSwatchSelector_item$ref & PdpRespPriceNegotiationToastLoader_item$ref & PdpRespRequestHoldToastLoader_item$ref & SuspectedTradeUserLoader_item$ref & PdpRespDealerDetails_item$ref & PdpRespHeroCarousel_item$ref & PdpRespDetails_item$ref & PdpSharedDescriptionAboutMaker_item$ref;
    readonly " $refType": PdpRespContainer_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PdpRespContainer_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fetchUser",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "isMultiSku",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "fetchPdp",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "small"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"small\")"
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "defaultSkuId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "itemType",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespSidebarSellerInfo_seller",
                        "args": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "skus",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSkuType",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": "skuLeadTime",
                        "name": "leadTime",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                            }
                        ],
                        "storageKey": "leadTime(pageType:\"PDP\")"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespExitModal_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSimilarItemsLanding_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespBreadcrumbs_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespHeroCarouselPrint_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespIconBubblesWrapper_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespTitle_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSidebarButtons_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSidebarBlurbs_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedDescriptionAbout_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedDescriptionAboutCreator_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedDescriptionAdditionalOptions_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespShippingReturns_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSidebarContact_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSeoLinks_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSimilarItemsGridSeller_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespSimilarItemsFooter_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedQuantitySelect_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedRecentHistoryTracker_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PriceDisplay_item",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "hasUserId",
                        "variableName": "fetchUser"
                    },
                    {
                        "kind": "Variable",
                        "name": "userId",
                        "variableName": "userId"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpSharedPromoCode_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isMultiSku",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespSwatchSelector_item",
                        "args": null
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespPriceNegotiationToastLoader_item",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespRequestHoldToastLoader_item",
                        "args": null
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SuspectedTradeUserLoader_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PdpRespDealerDetails_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchPdp",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespHeroCarousel_item",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpRespDetails_item",
                        "args": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "PdpSharedDescriptionAboutMaker_item",
                        "args": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '86a241af7080dbac4f6098b318c0b6a7';
export default node;
